<script setup lang="ts">
import FormErrors from '@ui/components/form/Errors.vue'

import { useOrientation } from '@ui/composables/form/useOrientation'
import { useTailwindClasses } from '@ui/composables/useTailwindClasses'
import { useValidation } from '@ui/composables/form/useValidation'

import type { Orientation } from '@ui/types/base/orientation'

const props = withDefaults(
  defineProps<{
    orientation?: Orientation
    showErrors?: boolean
    validation?: any
  }>(),
  {
    orientation: 'vertical',
    showErrors: true,
    validation: undefined
  }
)

const { orientation, showErrors, validation } = toRefs(props)

const errors = computed(() => {
  return validation?.value?.$errors ?? []
})
</script>

<template>
  <div
    :class="[
      'ui-form-group',
      useTailwindClasses([useOrientation(orientation), useValidation(validation)]),
      {
        invalid: errors.length
      }
    ]"
  >
    <slot />
    <FormErrors
      v-if="errors.length && showErrors"
      :errors="errors"
    >
      <slot name="errors" />
    </FormErrors>
    <div v-if="$slots.append">
      <slot name="append" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.ui-form-group {
  &.invalid {
    :deep(input),
    :deep(textarea),
    :deep(select) {
      @apply border-danger text-danger focus:border-danger focus-visible:outline-error;
    }
  }
  &.valid {
    :deep(input),
    :deep(textarea),
    :deep(select) {
      @apply border-success text-success focus:border-success focus-visible:outline-success;
    }
  }
}
</style>
